import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Configuration pour désactiver les redémarrages automatiques
const MANUAL_RESTART_ONLY = process.env.REACT_APP_MANUAL_RESTART_ONLY === 'true' || true;

// Désactiver le rechargement à chaud (Hot Module Replacement) si configuré
if (MANUAL_RESTART_ONLY && module.hot) {
  console.log('🔒 Mode redémarrage automatique du client: Désactivé');
  module.hot.decline();
}

// Désactiver la fonction de Fast Refresh si configurée
if (MANUAL_RESTART_ONLY && window.sessionStorage) {
  window.sessionStorage.setItem('DISABLE_FAST_REFRESH', 'true');
}

console.log('⚙️ Mode redémarrage du client: Manuel uniquement');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode désactivé pour éviter les double-rendus et comportements inattendus
  <App />
); 